<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Ingresar">
          <v-form ref="form" v-model="valid" lazy-validation @submit="recaptcha()">
            <v-row align="center">
              <v-col cols="12" sm="12" xs="12" md="2" lg="2" xl="2">
                <InputCustom :inputProp="inputs[3]" />
              </v-col>
              <v-col cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>
              <v-col cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>
            </v-row>
          </v-form>
        </CardIeaApp>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-btn @click="recaptcha()" block x-large class="white--text rounded-lg font-weight-regular" depressed
          color="btnSuccess" :disabled="!valid">Ingresar</v-btn>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn @click="olvidoPass()" block x-large class="grey--text text-decoration-underline font-weight-regular"
          depressed text color="#FFFFFF" :disabled="!valid">Olvíde mi contraseña</v-btn>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn @click="olvidoUser()" block x-large class="grey--text text-decoration-underline font-weight-regular"
          depressed text color="#FFFFFF" :disabled="!valid">Olvíde mi usuario</v-btn>
      </v-col>
      <br /><br /><br /><br /><br />
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// @ is an alias to /src
import CardIeaApp from "../components/CardIeaApp";
import CardIeaAppMain from "../components/CardIeaAppMain";
import InputCustom from "../components/InputCustom";
import MessagesRules from "../config/MessagesRules";

export default {
  name: "Login",
  components: {
    CardIeaApp,
    InputCustom,
    CardIeaAppMain
  },
  // computed: {
  //   loader() {
  //     return this.$store.getters.loader;
  //   }
  // },
  data: () => ({
    valid: true,
    inputs: [
      {
        tag: "username",
        text: "Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Usuario" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "password",
        text: "Contraseña",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "",
        type: "password",
        rules: [v => !!v || "Contraseña" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "web",
        text: "web",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "true",
        type: "hidden",
        counter: 0
      },
      {
        tag: "tipoUsuario",
        text: "Tipo de Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "select",
        rules: [v => !!v || "Tipo de Usuario" + MessagesRules.required],
        counter: 0,
        data: [
          { text: "Alumno", value: "alumno" },
          { text: "Profesor", value: "profesor" },
          { text: "Empresa", value: "empresa" },
          { text: "Operador", value: "operador" },
        ]
      },

    ]
  }),
  methods: {
    seguirInscripcion() {
      this.$router.push({ name: 'CargaArchivo' })
    },
    async recaptcha() {
      console.log("recaptcha clicked");
      await this.$recaptchaLoaded().then(() => {
        console.log("recaptcha loaded");
        this.$recaptcha("login").then((token) => {
          console.log(token)
          if (token) {
            this.login(token);
          }
          console.log(token); // Will print the token
        });
      });
    },
    async login(token_rc) {
      let that = this;
      if (this.$refs.form.validate()) {
        let loginUrl = "";
        let userType = this.inputs[3].value;
        that.inputs.push({ tag: "token_rc", value: token_rc });
        switch (userType) {
          case "profesor":
            loginUrl = "profesor/login";
            break;
          case "alumno":
            loginUrl = "alumno/login";
            break;
          case "empresa":
            loginUrl = "empresa/login";
            break;
          case "operador":
            loginUrl = "operador/login";
            break;
        }
        console.log('Si entra aqui----------->------------>', userType)

        await this.$API.post({
          url: loginUrl,
          data: that.inputs,
          form: true
        }).then(res => {
          console.log(res);
          let userPayload = {};

          switch (userType) {
            case "profesor":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.usu_nombre,
                docente: res.user.docentes,
                puntaje: res.user.puntaje,
                vendedor: res.user.vendedor,
                email: res.user.email,
                cobrador: res.user.cobrador,
                tipoUsuario: "profesor"
              };
              break;
            case "alumno":
              userPayload = {
                IDStB: res.user.IDStB,
                Nombres: res.user.Nombres,
                Apellidos: res.user.Apellidos,
                imagen: res.user.imagen,
                borrado: res.user.Borrado === '1' || res.user.alumno_mora ? '1' : '',
                borrado_real:res.user.Borrado_real,
                puntaje: res.user.puntaje,
                excedente: res.user.excedente,
                tipoUsuario: "alumno",
                kanban: res.user.kanban,
                deudaAlumno: res.user.validarDeuda.deuda,
                validacion_inscripcion:res.user.validacion_inscripcion,
                pendiente_documentos_inscripcion:res.user.validacion_inscripcion
              };
              that.$store.dispatch("tieneBadge1", res.tieneBadge1);
              that.$store.dispatch("tieneBadge2", res.tieneBadge2);
              that.$store.dispatch("tieneBadge3", res.tieneBadge3);
              that.$store.dispatch("porcentaje1", res.porcentaje1);
              that.$store.dispatch("porcentaje2", res.porcentaje2);
              that.$store.dispatch("porcentaje3", res.porcentaje3);
              that.$store.dispatch("primeroIngreso", res.primeroIngreso);
              that.$store.dispatch("carreraPrincipal", res.cursoPrincipal);
              if (res.imagenbase64 != null) {
                if (res.imagenbase64.length <= 20000) {
                  that.$store.dispatch("imagenbs", res.imagenbase64);
                } else {
                  console.warn('Imagen base64 data too large to store in localStorage');
                }
              }

              break;
            case "empresa":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.razon_social,
                quit: res.user.quit,
                direccion: res.user.direccion,
                telefono: res.user.telefono,
                email: res.user.email,
                responsable: res.user.responsable,
                tipoUsuario: "empresa"
              };
              break;
            case "operador":
              userPayload = {
                IDStB: res.user.id,
                Nombres: res.user.nombre,
                telefono: res.user.telefono,
                email: res.user.email,
                tipoUsuario: "operador"
              };
              break;
          }

          that.$store.dispatch("token", res.token_type + " " + res.access_token);
          that.$store.dispatch("user", userPayload);

          // Ensure all necessary data is loaded before redirecting
          that.ensureDataLoaded().then(() => {
            const storedCallback = localStorage.getItem('callback');
            if (storedCallback) {
              localStorage.removeItem('callback');
              this.$router.push(storedCallback);
            } else {
              setTimeout(() => {
                const destination = userType === 'profesor' ? 'HomeProfesor' : 'Home';
                that.$router.replace({ name: destination });
              }, 2000);
            }
          });
        });


      }
    },
    async ensureDataLoaded() {
      // Add any necessary checks or additional API calls here
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500); // Arbitrary delay to simulate data loading
      });
    },

    async olvidoPass() {
      this.$router.replace({ name: "ResetPassword" });
    },
    async olvidoUser() {
      this.$router.replace({ name: "RecoverUser" });
    }
  }
};
</script>